class ArtistasGridFilter {
  constructor() {
    this.init();
  }

  init() {
    // Não fazer nada aqui - toda a lógica de filtro está em artistas-load-more.js
    // Este arquivo pode ser mantido para compatibilidade ou removido depois
    console.log('ArtistasGridFilter inicializado (desativado - filtros gerenciados por ArtistasLoadMore)');
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ArtistasGridFilter();
  });
} else {
  new ArtistasGridFilter();
}